import moment from 'moment';

export const DATEFORMAT_KEY = 'dateFormat';
export const CALENDAR_START_DAY_KEY = 'calendarStartingDay';
export class fsDateUtils {
    static toString(htmlCode, userService, $cookies, mappingFunction, keepLocalTime) {
        if (htmlCode == null) {
            return null;
        }

        // init dateformat refresh case uses $cookies stored dateFormat
        let format = userService.fsMainDependencies.settings   ?
            JSON.parse(JSON.stringify(mappingFunction( userService.fsMainDependencies.settings.dateTimeFormat))) :
            JSON.parse(JSON.stringify($cookies.get(DATEFORMAT_KEY)));

        if(format) {
            // new deep clone copy
            $cookies.put(DATEFORMAT_KEY, format);
        }

        // https://momentjs.com/ needs modification lower case 'y' does not conform
        if(format.indexOf(" ") > 0) {
                const dateFormat = format.substr(0, format.indexOf(" ")).toUpperCase();
                const timeFormat = format.substr(format.indexOf(" "), format.length);
                format = dateFormat + timeFormat;
        } else {
            format = format.toUpperCase();
        }

        const date = angular.isNumber(htmlCode) ?
                moment.unix(htmlCode / 1000).utc(keepLocalTime) : moment(htmlCode).utc(keepLocalTime);
        return keepLocalTime ? date.format(format) : date.utc().format(format);
    }
}
